import { CommonModule, DatePipe, Location, CurrencyPipe, TitleCasePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

//import * as $ from "jquery"; //do not remove unless jQuery dependency used by froala is removed!
//window["$"] = $;
//window["jQuery"] = $;


//import "froala-editor/js/froala_editor.pkgd.min.js";

import { AgGridModule } from "ag-grid-angular";
import { FullCalendarModule } from "@fullcalendar/angular";

import { AlertComponent } from "./components/alert.component";
import { BreadcrumbsComponent } from "./components/breadcrumbs.component";
import { LoaderComponent } from "./components/loader.component";
import { RulesEditorComponent } from "./components/rules-editor/rules-editor.component";
import { SVGIconComponent } from "./components/svg-icon.component";
import { SymbolDefsComponent } from "./components/symbol-defs.component";
import { DynamicComponentLoaderDirective } from "./directives/dynamic-component-loader.directive";
import { PopoverDirective } from "./directives/popover.directive";
import { KeyEventDirective } from "./directives/key-event.directive";
import { SetFocusDirective } from "./directives/set-focus.directive";
import { DateInputDirective} from "./directives/date-input.directive";
import { MessageService } from "./services/message.service";
import { NoteService } from "./services/note.service";
import { TabsComponent } from "./components/tabs/tabs.component";
import { TabComponent } from "./components/tabs/tab.component";
import { UrlPartValidatorService } from "./services/url-part-validator.service";
import { SidePanelComponent } from "./components/side-panel.component";
import { SidePanelService } from "./services/side-panel.service";
import { LoaderService } from "./services/loader.service";
import { PdfGeneratorService } from "./services/pdf-generator.service";
import { RouterLinkRendererComponent } from "./components/ag-grid/router-link-renderer.component";
import { ActionCellRendererComponent } from "./components/ag-grid/action-cell-renderer.component";
import { WorkOrderComponent } from "./components/work-order/work-order.component";
import { WorkOrderResolver } from "./resolvers/work-order.resolver";
import { ScanOrderResolver } from "./resolvers/scan-order.resolver";
import { PaymentResolver } from "./resolvers/payment.resolver";
import { DateService } from "./services/date.service";
import { ClickOutsideDirective } from "./components/directives/click-outside.directive";
import { RegistrationRequestService } from "./services/registration-request.service";
import { IconActionRendererComponent } from "./components/ag-grid/icon-action-renderer.component";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { SwitchRendererComponent } from "./components/ag-grid/switch-renderer.component";
import { FullCalendarComponent } from "../dashboard/components/widgets/calendar/full-calendar.component";
import { ReviewNotesComponent } from "./components/notes/review-notes.component";
import { FieldNotesComponent } from "./components/notes/field-notes.component";
import { HistoryComponent } from "./components/notes/history.component";
import { AddressBlockComponent } from "./components/utility/address-block.component";
import { PermitComponent } from "./components/permit/permit.component";
import { DisplayService } from "./services/display.service";
import { QueryService } from "./services/query.service";
import { CasingPlan2dSchematicComponent } from "../form-controls/components/casing-plan-schematic/casing-plan-2d/schematic/casing-plan-2d-schematic.component";
import { CasingPlan2dSchematicHorizontalComponent } from "../form-controls/components/casing-plan-schematic/casing-plan-2d/schematic/casing-plan-2d-schematic-horizontal.component";
import { CasingPlan2dSchematicVerticalComponent } from "../form-controls/components/casing-plan-schematic/casing-plan-2d/schematic/casing-plan-2d-schematic-vertical.component";
import { CasingPlan2dSchematicDirectionalComponent } from "../form-controls/components/casing-plan-schematic/casing-plan-2d/schematic/casing-plan-2d-schematic-directional.component";
import { GisModule } from "../gis/gis.module";
import { CasingPlan2dBaseComponent } from "../form-controls/components/casing-plan-schematic/casing-plan-2d/casing-plan-2d-base.component";
import { FinancialAssuranceService } from "./services/financial-assurance.service";
import { WellService } from "./services/well.service";
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { PipesModule } from "./pipes/pipes.module";
import { ReportingService } from "./services/reporting.service";
import { DocumentManagementService } from "./services/document-management.service";
import { StaticLoaderComponent } from './components/static-loader/static-loader.component';
import { UploadScannedDocumentsComponent } from './components/upload-scanned-documents/upload-scanned-documents.component';
import { DropdownSelectButtonModule } from "./components/dropdown-select-button/dropdown-select-button.module";
import { ApiService } from "./services/api.service";
import { PhoneNumberInputComponent } from "./components/phonenumber-input/phonenumber-input.component";
import { PaymentProcessingComponent } from './components/payment-processing/payment-processing.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { HistoryItemComponent } from './components/notes/history-item/history-item.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { TemplateService } from "./components/pdf-viewer/services/template.service";
import { SelectComponent } from './components/form-controls/select/select.component';
import { OptionComponent } from './components/form-controls/select/option/option.component';
import { SelectOptionDirective } from './components/form-controls/select/option.directive';
import { FinancialAssuranceInsuranceComponent } from "./components/financial-assurance/fa-insurance.component";
import { FinancialAssuranceBondingComponent } from "./components/financial-assurance/fa-bonding.component";
import { FinancialAssuranceListComponent } from "./components/financial-assurance/fa-list.component";
import { FinancialAssurancePendingComponent } from "./components/financial-assurance/fa-pending.component";
import { FinancialStatementManagementComponent } from "./components/financial-assurance/fa-statement-management.component";
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogService } from "./services/dialog.service";
import { PaymentDisplayItemComponent } from './components/payment-processing/payment-display-item/payment-display-item.component';
import { GridFormatterService } from "./services/grid-formatter.service";
import { IssuesService } from "./services/issues.service";
import { WorkOrderDetailComponent } from './components/work-order/work-order-detail/work-order-detail.component';
import { FinancialAssuranceReturnedFlowComponent } from "./components/financial-assurance/fa-returned-flow.component";
import { FinancialAssuranceNotSubmittedFlowComponent } from "./components/financial-assurance/fa-not-submitted-flow.component";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { ModalInfoComponent } from './components/ag-grid/modal-info.component';
import { AgGridBooleanFilterComponent } from "./components/ag-grid/filters/boolean-filter.component";
import { FlUploadDirective } from './directives/fl-upload.directive';
import { UploadViewFilesComponent } from './components/fileUpload/upload-view-files.component';
import { ReviewNotesCommonComponent } from './components/review-notes/review-notes-common.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { FlaggedComponent } from "./components/data-table/columns/flagged/flagged.component";
import { DetailsComponent } from "./components/data-table/columns/details/details.component";
import { DomainComponent } from "./components/data-table/columns/domain/domain.component";
import { TextLoaderComponent } from './components/text-loader/text-loader.component';
import { UploadedFileComponent } from './components/fileUpload/uploaded-file/uploaded-file.component';
import { AddAdHocReviewerComponent } from "../flow/components/add-ad-hoc-reviewer/add-ad-hoc-reviewer.component";
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { CommonDatePickerComponent } from './components/common-date-picker/common-date-picker.component';
import { ScanDocumentDetailsComponent } from './components/document-scanning-request/scan-document-details/scan-document-details.component';
import { DocumentScanningRequestComponent } from './components/document-scanning-request/document-scanning-request.component';
import { ReportCommandComponent } from './components/report-command/report-command.component';
import { WorkOrderService } from "./services/work-order.service";
import { OnBaseIntegrationAndMappingService } from "./services/onbase-integration-mapping.service";
import { OrganizationService } from "./services/organization.service";
import { DeltaBubbleComponent } from './components/delta-bubble/delta-bubble.component';
import { CheckboxRendererComponent } from "./components/ag-grid/checkbox-renderer.component";
import { DocumentSearchComponent } from './components/document-search/document-search.component';
import { DocumentSearchOptionsComponent } from './components/document-search/document-search-options/document-search-options.component';
import { DocumentSearchResultsComponent } from './components/document-search/document-search-results/document-search-results.component';
import { PaginationComponent } from "./components/pagination/pagination.component";
import { ColumnHeaderComponent } from './components/column-header/column-header.component';
import { HelpTextComponent } from "./components/help-text/help-text.component";
import { AccordionPanelComponent } from "./components/accordion/accordion-panel/accordion-panel.component";
import { AccordionComponent } from "./components/accordion/accordion.component";
import { HeightWidthService } from "./services/height-width.service";
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { FinancialAssuranceCompleteComponent } from "./components/financial-assurance/fa-complete.component";
import { FinancialAssuranceAwaitingReturnComponent } from "./components/financial-assurance/fa-awaiting-return.component";
import { OnBaseConfigurationComponent } from "./components/onbase/onbase-configuration.component";
import { CheckboxEditorComponent } from './components/ag-grid/checkbox-editor.component';
import { SectionIndicatorComponent } from './components/section-indicator/section-indicator.component';
import { ButtonRendererComponent } from './components/ag-grid/button-renderer.component';
import { NotesFilterComponent } from './components/notes/notes-filter/notes-filter.component';
import { ReapplicationReceiptComponent } from './components/reapplication-receipt/reapplication-receipt.component';
import { AdjustmentViewComponent } from './components/reapplication-receipt/adjustment-view/adjustment-view.component';
import { CriticalNotesComponent } from './components/critical-notes/critical-notes.component';
import { CriticalNoteService } from "./services/critical-note.service";
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';
import { OrganizationWellsGridComponent } from './components/organization/components/organization-wells/organization-wells-grid.component';
import { EditableGroupRowRendererComponent } from './components/ag-grid/editable-group-row-renderer.component';
import { SelectionIndicatorRendererComponent } from './components/ag-grid/selection-indicator-renderer.component';
import { SelectionColumnHeaderComponent } from './components/ag-grid/selection-column-header.component';
import { FinancialAssurancePendingInternalComponent } from "./components/financial-assurance/fa-pending-internal.component";

const OWL_DATE_FORMATS = {
    parseInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    fullPickerInput: { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit' },
    datePickerInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    timePickerInput: { hour: 'numeric', minute: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
};

@NgModule({
    imports: [
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        FullCalendarModule,
        PipesModule,
        GisModule,
        DropdownSelectButtonModule,
        NgxExtendedPdfViewerModule,
        NgxMaskModule,
        AgGridModule, //.withComponents([AgGridBooleanFilterComponent, FlaggedComponent, DetailsComponent, DomainComponent]), 
        NgSelectModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule
    ],
    declarations: [
        ActionCellRendererComponent,
        AlertComponent,
        BreadcrumbsComponent,
        CasingPlan2dBaseComponent,
        CasingPlan2dSchematicComponent,
        CasingPlan2dSchematicHorizontalComponent,
        CasingPlan2dSchematicVerticalComponent,
        CasingPlan2dSchematicDirectionalComponent,
        ClickOutsideDirective,
        LoaderComponent,
        SVGIconComponent,
        SymbolDefsComponent,
        RouterLinkRendererComponent,
        RulesEditorComponent,
        PopoverDirective,
        DynamicComponentLoaderDirective,
        KeyEventDirective,
        SetFocusDirective,
        DateInputDirective,
        SidePanelComponent,
        TabsComponent,
        TabComponent,
        WorkOrderComponent,
        IconActionRendererComponent,
        SwitchRendererComponent,
        FullCalendarComponent,
        IconActionRendererComponent,
        ReviewNotesComponent,
        FieldNotesComponent,
        HistoryComponent,
        PermitComponent,
        AddressBlockComponent,
        StaticLoaderComponent,
        UploadScannedDocumentsComponent,
		PhoneNumberInputComponent,
        PaymentProcessingComponent,
        ReceiptComponent,
        HistoryItemComponent,
        PdfViewerComponent,
        SelectComponent,
        OptionComponent,
        SelectOptionDirective,
        FinancialAssuranceBondingComponent,
        FinancialAssuranceInsuranceComponent,
        FinancialAssuranceListComponent,
        FinancialAssurancePendingComponent,
        FinancialStatementManagementComponent,
        FinancialAssuranceNotSubmittedFlowComponent,
        FinancialAssuranceReturnedFlowComponent,
        FinancialAssuranceCompleteComponent,
        FinancialAssuranceAwaitingReturnComponent,
        DialogComponent,
        PaymentDisplayItemComponent,
        ModalInfoComponent,
        WorkOrderDetailComponent,
        FlUploadDirective,
        UploadViewFilesComponent,
        ReviewNotesCommonComponent,
        ModalInfoComponent,
        AgGridBooleanFilterComponent,
        FlaggedComponent,
        DetailsComponent,
        TimelineComponent,
        DomainComponent,
        TextLoaderComponent,
        UploadedFileComponent,
        AddAdHocReviewerComponent,
        TextEditorComponent,
        CommonDatePickerComponent,
        ScanDocumentDetailsComponent,
        DocumentScanningRequestComponent,
        ReportCommandComponent,
        DeltaBubbleComponent,
        CheckboxRendererComponent,
        DocumentSearchComponent,
        DocumentSearchOptionsComponent,
        DocumentSearchResultsComponent,
        PaginationComponent,
        ColumnHeaderComponent,
        HelpTextComponent,
        AccordionPanelComponent,
        AccordionComponent,
        OnBaseConfigurationComponent,
        CheckboxEditorComponent,
        SectionIndicatorComponent,
        ButtonRendererComponent,
        NotesFilterComponent,
        ReapplicationReceiptComponent,
        AdjustmentViewComponent,
        CriticalNotesComponent,
		PreventDoubleClickDirective,
		OrganizationWellsGridComponent,
		EditableGroupRowRendererComponent,
        SelectionIndicatorRendererComponent,
        SelectionColumnHeaderComponent,
        FinancialAssurancePendingInternalComponent
    ],
    providers: [
        ReportingService,
        DisplayService,
        LoaderService,
        Location,
        MessageService,
        NoteService,
        SidePanelService,
        UrlPartValidatorService,
        WorkOrderResolver,
        ScanOrderResolver,
        PaymentResolver,
        DateService,
        UrlPartValidatorService,
        RegistrationRequestService,
        PdfGeneratorService,
        ApiService,
        FinancialAssuranceService,
        WellService,
        CurrencyPipe,
        DocumentManagementService,
        QueryService,
        ApiService,
        TemplateService,
        DialogService,
        GridFormatterService,
        IssuesService,
        CanDeactivateGuardService,
        WorkOrderService,
        OnBaseIntegrationAndMappingService,
        OrganizationService,
        HeightWidthService,
		CriticalNoteService,
		TitleCasePipe,
        { provide: OWL_DATE_TIME_FORMATS, useValue: OWL_DATE_FORMATS }
    ],
    exports: [
        ActionCellRendererComponent,
        AgGridModule,
        AlertComponent,
        DropdownSelectButtonModule,
        BreadcrumbsComponent,
        CasingPlan2dBaseComponent,
        CasingPlan2dSchematicComponent,
        CasingPlan2dSchematicHorizontalComponent,
        CasingPlan2dSchematicVerticalComponent,
        CasingPlan2dSchematicDirectionalComponent,
        DatePipe,
        CurrencyPipe,
        PipesModule,
        LoaderComponent,
        SVGIconComponent,
        AddressBlockComponent,
        SymbolDefsComponent,
        RouterLinkRendererComponent,
        RulesEditorComponent,
        PopoverDirective,
        SetFocusDirective,
        DynamicComponentLoaderDirective,
        KeyEventDirective,
        SidePanelComponent,
        TabsComponent,
        TabComponent,
        //MyDatePickerModule,
        FroalaEditorModule,
        FroalaViewModule,
        FullCalendarComponent,
        StaticLoaderComponent,
		PhoneNumberInputComponent,
        ReceiptComponent,
        SelectComponent,
        PdfViewerComponent,
        OptionComponent,
        SelectOptionDirective,
        FinancialAssuranceBondingComponent,
        FinancialAssuranceInsuranceComponent,
        FinancialAssuranceListComponent,
        FinancialAssurancePendingComponent,
        FinancialAssurancePendingInternalComponent,
        FinancialStatementManagementComponent,
        FinancialAssuranceNotSubmittedFlowComponent,
        FinancialAssuranceReturnedFlowComponent,
        FinancialAssuranceCompleteComponent,
        FinancialAssuranceAwaitingReturnComponent,
        DialogComponent,
        WorkOrderDetailComponent,
        UploadViewFilesComponent,
        UploadedFileComponent,
        TextLoaderComponent,
        AddAdHocReviewerComponent,
        TextEditorComponent,
        CommonDatePickerComponent,
        ScanDocumentDetailsComponent,
        DocumentScanningRequestComponent,
        ReportCommandComponent,
        DeltaBubbleComponent,
        PaginationComponent,
        ColumnHeaderComponent,
        DocumentSearchResultsComponent,
        DocumentSearchOptionsComponent,
        HelpTextComponent,
        AccordionPanelComponent,
        AccordionComponent,
        NgSelectComponent,
        OnBaseConfigurationComponent,
        SectionIndicatorComponent,
        ReapplicationReceiptComponent,
		CriticalNotesComponent,
		PreventDoubleClickDirective,
		OrganizationWellsGridComponent,
		EditableGroupRowRendererComponent
    ]
})
export class LunaCommonModule { }
